"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styles = {
  px: 4,
  mx: 'auto',
  maxW: {
    base: 'container.base',
    tablet: 'container.tablet',
    desktop: 'container.desktop'
  }
};
var _default = exports.default = styles;